// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function referencesFromProductData(data, shops) {
  return data.productsByVariantCku.edges.map(param => {
    let product = param.node;
    return {
      id: product.id,
      shopId: product.shop.id,
      formattedName: product.name,
      variantsCku: product.variants.edges.map(param => param.node.cku),
      productName: product.name,
      productKind: product.kind,
      productColor: product.color,
      productProducer: product.producer
    };
  }).filter(product => Stdlib_Option.isSome(shops.find(shop => shop.id === product.shopId)));
}

function referencesFromVariantData(data, shops) {
  return Stdlib_Array.filterMap(data.variantsByCku.edges, param => {
    let variant = param.node;
    return {
      id: variant.id,
      shopId: variant.shop.id,
      formattedName: variant.formattedName,
      variantsCku: variant.product.variants.edges.map(param => param.node.cku),
      productName: variant.product.name,
      productKind: variant.product.kind,
      productColor: variant.product.color,
      productProducer: variant.product.producer
    };
  }).filter(variant => Stdlib_Option.isSome(shops.find(shop => shop.id === variant.shopId)));
}

function shopsDataFromReferences(references, shops) {
  return shops.map(shop => {
    let match = references.find(reference => reference.shopId === shop.id);
    return {
      dataId: shop.id,
      dataName: shop.name,
      duplicability: match !== undefined ? "ExistsAlready" : "Duplicable"
    };
  });
}

function use(productResponse, variantResponse, duplicationMode) {
  let scope = Auth.useScope();
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  if (shops.length === 0) {
    return "Loading";
  }
  if (duplicationMode === "Product") {
    if (productResponse.TAG !== "Executed") {
      return "Loading";
    }
    let match = productResponse._0;
    let productData = match.data;
    if (match.loading) {
      return "Loading";
    }
    if (productData === undefined) {
      return "Error";
    }
    if (scope.TAG !== "Organisation") {
      return "Error";
    }
    let references = referencesFromProductData(productData, shops);
    let shopsData = shopsDataFromReferences(references, shops);
    let match$1 = references.find(param => param.shopId === Stdlib_Option.map(activeShop, param => param.id));
    let source = activeShop !== undefined && match$1 !== undefined ? ({
        TAG: "Product",
        _0: {
          id: match$1.id,
          shopId: activeShop.id
        }
      }) : undefined;
    let availableShops = shopsData.filter(shop => shop.duplicability === "ExistsAlready");
    let source$1 = availableShops.length === 1 ? Stdlib_Option.mapOr(references.find(param => param.shopId === availableShops[0].dataId), source, param => ({
        TAG: "Product",
        _0: {
          id: param.id,
          shopId: param.shopId
        }
      })) : source;
    return {
      TAG: "Data",
      _0: {
        references: references,
        shopsData: shopsData,
        initialValues: {
          source: source$1,
          destinations: []
        }
      }
    };
  }
  if (variantResponse.TAG !== "Executed") {
    return "Loading";
  }
  let match$2 = variantResponse._0;
  let variantData = match$2.data;
  if (match$2.loading) {
    return "Loading";
  }
  if (variantData === undefined) {
    return "Error";
  }
  if (scope.TAG !== "Organisation") {
    return "Error";
  }
  let references$1 = referencesFromVariantData(variantData, shops);
  let shopsData$1 = shopsDataFromReferences(references$1, shops);
  let match$3 = references$1.find(param => param.shopId === Stdlib_Option.map(activeShop, param => param.id));
  let source$2 = activeShop !== undefined && match$3 !== undefined ? ({
      TAG: "Variant",
      _0: {
        id: match$3.id,
        shopId: activeShop.id
      }
    }) : undefined;
  let availableShops$1 = shopsData$1.filter(shop => shop.duplicability === "ExistsAlready");
  let source$3 = availableShops$1.length === 1 ? Stdlib_Option.mapOr(references$1.find(param => param.shopId === availableShops$1[0].dataId), source$2, param => ({
      TAG: "Variant",
      _0: {
        id: param.id,
        shopId: param.shopId
      }
    })) : source$2;
  return {
    TAG: "Data",
    _0: {
      references: references$1,
      shopsData: shopsData$1,
      initialValues: {
        source: source$3,
        destinations: []
      }
    }
  };
}

let ProductsQuery;

let VariantsQuery;

export {
  ProductsQuery,
  VariantsQuery,
  referencesFromProductData,
  referencesFromVariantData,
  shopsDataFromReferences,
  use,
}
/* Auth Not a pure module */
